<template>
  <div class="d-flex h-100">
    <div class="d-flex m-auto">
      <div
        class="sk-chase"
        :style="`--color: var(--bs-${color}); width: ${width}px; height: ${height}px;`"
      >
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingAnimation',
  props: {
    color: {
      required: false,
      type: String,
      default: 'blue-500',
    },
    width: {
      type: [Number, String],
      default: 30,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/animation.scss";
.sk-chase-dot:before {
  background-color: var(--color);
}
</style>
